import React from 'react'
import { defaultFaIconCx } from './style'

type Props = React.HTMLAttributes<HTMLElement>

const FaDelete = ({ style, ...props }: Props) => {
  const mergedClassName = ['fa-regular fa-trash-can', defaultFaIconCx].join(' ')

  return (
    <i className={mergedClassName} style={!style ? { color: '#d32f2f' } : undefined} {...props}></i>
  )
}

export default React.memo(FaDelete)
